import { useLanguage } from "../../../../../../../context/LanguageContext";
import { useAdminProductsTranslation } from "../../../../translations";

export const DiscountValueInput = ({ discountType, value, onChange }) => {
    const { language } = useLanguage();
    const { t } = useAdminProductsTranslation(language);

    return (
        <div className="form-group">
            <label>
                {t('discountValue')} {discountType === "percentage" ? "(%)" : "(AED)"}
            </label>
            <input
                type="number"
                min="0"
                max={discountType === "percentage" ? "100" : undefined}
                step="0.01"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                required
            />
        </div>
    );
};

export default DiscountValueInput;